import { VApp } from 'vuetify/lib/components/VApp';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,[(_vm.isLoggedIn)?[_c('pinpoll-navigation-drawer'),_c('pinpoll-toolbar'),_c('pinpoll-content')]:[_c('pinpoll-content')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }